// import formatterDateMixin from './datetime'
import { parseData, handleErr, randomString, formatNum } from '@/utils'
import { apiGet } from '@/services'

export const queryMixin = {

  methods: {
		/**
		 * @Author    lichin
		 * @DateTime  2018-01-10
		 * @copyright 传入对象数组过滤未被靶中的字段
		 * @license   [license]
		 * @version   [version]
		 * @param     {[type]}    keys   [传入的数组对象集]
		 * @param     {[type]}    search [查询参数]
		 * @return    {[type]}           [处理后的参数]
		 */
    filterQuery(search) {
      const { searchKeyMap } = this
      for (const key in searchKeyMap) {
        searchKeyMap[key].map(item => {
          if (item !== search[key]) {
            delete search[item]
          }
        })
      }
      return search
    },

    getQuery() {
      let query = { ...this.search }
      query = this.filterQuery(query)

      for (const key in query) {
        if (query[key] === '' || query[key] === undefined || query[key] === null) {
          delete query[key]
        }
      }
      return query
    }
  }
}

export const listMixin = {

  computed: {
    list() {
      let data = parseData(this.data)
      if (this.sortKeys) {
        data = data.sort(this.sortData)
      }
      const start = this.pageSize * (this.pageIndex - 1)
      return this.local ? (this.various ? data : data.slice(start, this.pageSize * this.pageIndex)) : data
    }
  },

  props: {
    app: Object
  },

  mixins: [queryMixin],

  data() {
    return {
      data: [],
      lazyLoading: false,
      selection: [],
      finished: false,
      includeKeyWord: [],
      selectionRow: [],
      loading: false,
      total: 0,
      pageIndex: 1,
      pageSize: 10
    }
  },

  methods: {
    // getDataLen 获取返回数据条数，用来操作该返回值为零，改变参数重新请求
    async onSearch() {
      this.pageIndex = 1
      const getDataLen = await this.getList()
      this.selection = []
      this.extra && this.extra()
      return getDataLen
    },

    getList() {
      const {
        pageIndex,
        pageSize,
        api,
        lazyLoading
      } = this

      if (!lazyLoading && (!api || this.loading)) {
        return false
      }
      this.loading = true
      const query = { pageIndex, pageSize, ...this.getQuery(), _k: randomString() }
      return apiGet(this.api, query).then(res => {
        this.loading = false
        if (res.code === '0000') {
          let data = res.data
          if (this.filterDataFunc) {
            data = this.filterDataFunc(data)
          }
          // 懒加载就叠加
          this.data = lazyLoading ? this.data.concat(data) : data
          this.total = res.total
          if (lazyLoading) {
            if (this.pageSize * this.pageIndex < this.total) {
              this.finished = false
              this.pageIndex += 1
            } else {
              this.finished = true
            }
          }
          return this.total
        } else {
          handleErr(res.msg)
          return -1
        }
      })
    },

    onLoad() {
      if (!this.finished) {
        this.getList()
      }
    },

    clearList() {
      this.loading = false
      this.pageIndex = 1
      this.total = 0
      this.selection = []
    },

    sortData(a, b) {
      if (this.sortKeys && this.sortKeys.length > 0) {
        // 如果需要对比
        for (const value of this.sortKeys) {
          const keyArr = value.split('-')
          const key = keyArr[keyArr.length - 1]
          if (a[key] < b[key]) {
            return keyArr.length > 1 ? -1 : 1
          }
          if (a[key] > b[key]) {
            return keyArr.length > 1 ? 1 : -1
          }
        }
        return 0
      } else {
        return -1
      }
    },

    onPageChange(pageIndex) {
      this.pageIndex = pageIndex
      this.getList().then(() => {
        if (this.isAllPageSelected) {
          this.$refs.table && this.$refs.table.toggleAllSelection()
        }
      })
    },

    onPageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageIndex = 1
      this.getList()
    },

    onSelectionChange(selectedArr, key = 'id') {
      this.selection = this.tableKey ? selectedArr.map(item => item[this.tableKey || key]) : selectedArr
      this.selectionRow = selectedArr
    },

    getSummary(store) {
      const { selectionRow: selection, includeKeyWord } = this
      const { columns: cols, data } = store
      const defaultKeyWord = ['fee', 'amount', /count$/gi]
      const sums = new Array(cols.length)
      sums[0] = this.$t('app.word.total')

      // if (!this.isAllPageSelected) {

      // 计算 当前页所有行 or 选择的行
      const rowData = selection.length > 0 ? selection : data
      if (rowData.length === 0) {
        return []
      }

      // 筛选出当前列表页所有列中，prop包含关键字的列
      cols.forEach((col, index) => {
        const { property: prop } = col
        if (!prop) {
          return false
        }
        // 是否包含关键字
        const isIncludeDefaultKeyWord = defaultKeyWord.find(i => {
          return typeof i === 'string'
            ? new RegExp(i, 'gi').test(prop)
            : i.test(prop)
        })
        const isIncludeKeyWord = includeKeyWord.find(i => { return i === prop })
        if (isIncludeDefaultKeyWord !== undefined || isIncludeKeyWord !== undefined) {
          // 计算所有行中该字段的总和
          const colData = rowData.map(item => item[prop])
          const sum = colData.reduce((total, curr) => {
            const value = parseFloat(curr)
            return ((total * 100) + (value * 100)) / 100
          })
          sums[index] = formatNum(sum, new RegExp(/count/gi).test(prop))
        }
      })
      // } else {
      // form server
      // }

      return sums
    },

    watchKey() {
      const { searchKeyMap, unWatchKeyMap } = this
      for (const item in searchKeyMap) {
        if (unWatchKeyMap && unWatchKeyMap.includes(item)) {
          continue
        }
        this.$watch(`search.${item}`, function (newKey, oldKey) {
          if (newKey) {
            const cacheVal = this.search[oldKey]
            for (const key of searchKeyMap[item]) {
              this.search[key] = cacheVal
            }
          }
        })
      }
    }
  },

  mounted() {
    this.init && this.init()
    if (!this.manual) {
      this.onSearch()
    }
    this.watchKey()
  },

  activated() {
    // 当不含_k 且 左侧切入的时候 （刚开启标签页）
    if (!this.$route.query._k) {
      this.init && this.init()
      if (!this.manual) {
        this.onSearch()
      }
    }
  }
}
